import React from 'react';
import PropTypes from 'prop-types';

import Step from '../Step';

import styles from './ProgressBar.module.scss';

const ProgressBar = (props) => {
  const { steps, currentStepNumber, unlockedSteps, goToStep } = props;
  return (
    <div className={styles.progressBarBackground}>
      <div className={styles.progressBarWrapper}>
        <div className={styles.progressBar}>
          {steps.map((s) => (
            <Step
              key={s.id}
              step={s}
              isUnlocked={unlockedSteps.includes(s.id)}
              isTouched={s.n <= currentStepNumber}
              isCurrent={s.n === currentStepNumber}
              goToStep={goToStep}
              style={{ width: `${100 / steps.length}%` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  unlockedSteps: PropTypes.arrayOf(PropTypes.string),
  currentStepNumber: PropTypes.number,
  goToStep: PropTypes.func,
};

ProgressBar.defaultProps = {
  currentStepNumber: 1,
  unlockedSteps: [],
  goToStep: () => {},
};

export default ProgressBar;
